import React from 'react';
import { Col, Row } from 'react-bootstrap';
import NoData from '../../../components/Ui/NoData';

const ViewAddresses = () => {
	return (
		<>
			<div>
				<h2 className="text-start">View Addresses</h2>
				<div className="doted-container"></div>
			</div>
			<Row className="gy-3">
				<Col xs={6}>
					<div className="h5">Name & Phone Number</div>
					<div>Mustaque Nadim</div>
					<div>+8801789667072</div>
				</Col>
				<Col xs={6}>
					<div className="h5">Region</div>
					<div>Dhaka - Dhaka - North - Bashundhara R/A</div>
				</Col>
				<Col xs={12}>
					<div className="h5">Address</div>
					<div>
						Adept K.R Complex, 2nd Floor, Bashundhara R/A Link Road, Dhaka-1229,
						Bangladesh
					</div>
				</Col>
			</Row>
			<NoData />
		</>
	);
};

export default ViewAddresses;
